import * as React from "react"

export default function IconTiktok({ fill }) {
  return (
    <svg
      width="37"
      height="41"
      viewBox="0 0 35.59 40.81"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M30.27,8.18c-2.2-1.43-3.78-3.73-4.28-6.4-.11-.58-.17-1.17-.17-1.78h-7.02v28.12c-.13,3.15-2.72,5.68-5.9,5.68-.99,0-1.92-.25-2.74-.68-1.88-.99-3.16-2.96-3.16-5.22,0-3.25,2.65-5.9,5.9-5.9.61,0,1.19.1,1.74.27v-7.16c-.57-.08-1.15-.13-1.74-.13C5.79,14.98,0,20.77,0,27.9c0,4.37,2.18,8.23,5.51,10.57,2.1,1.47,4.65,2.34,7.4,2.34,7.12,0,12.91-5.79,12.91-12.91v-14.26c2.75,1.97,6.12,3.14,9.76,3.14v-7.02c-1.96,0-3.78-.58-5.32-1.58Z"
        fill={fill}
      />
    </svg>
  )
}